"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Performs final cleanup at a state level by freezing the state's top-level
 * value once all batched actions for the entire state are complete.
 */
var completesStateUpdate = function (state) {
    state.isActioning = false;
    if (process.env.NODE_ENV !== 'production') {
        Object.freeze(state.value);
    }
};
exports.default = completesStateUpdate;
//# sourceMappingURL=completeStateUpdate.js.map